/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/accessibility",
  shortTitle: "Accessibility",
  title: "Accessibility statement",
  category: "Data and website",
  summary: "The current accessibility approach for navigation, product information, forms and workshop adjustments.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "Scope and current measures",
      body: [
        `${siteConfig.brandName} aims to make browsing, product comparison and checkout usable with keyboard input, screen magnification and common assistive technology. The implementation uses semantic headings, labelled controls, visible focus, text alternatives for meaningful images, a responsive layout and buttons that are not identified by colour alone.`,
      ],
    },
    {
      heading: "Product and policy information",
      body: [
        "Product pages present names, prices, materials, dimensions, care and safety in text rather than hiding essential information inside images. More navigation can be opened by click and reports its expanded state. Policy pages use consistent headings and internal links. Payment card entry occurs on a hosted page whose accessibility is also the responsibility of that service.",
      ],
    },
    {
      heading: "Workshop and communication adjustments",
      body: [
        "The workshop listing cannot promise a venue or adjustment that has not been confirmed. A prospective participant should email the barrier encountered or adjustment needed before final attendance is agreed. Customer care can also provide product or policy information in a simpler email format where reasonably practicable.",
      ],
    },
    {
      heading: "Report a barrier",
      body: [
        `Send the page URL, device, browser or assistive technology, the task attempted and what happened. Do not send medical details beyond what is needed to explain an adjustment. ${siteConfig.brandName} will acknowledge, investigate and provide a practical alternative where possible, then prioritise a code or content correction. No conformance certification or fixed remediation deadline is claimed because none has been independently confirmed.`,
      ],
    },
  ],
};
